module.exports = __webpack_public_path__ + "static/media/halasz_fishing_img03.b0a9c0f9.png";